import { on } from "@ngrx/store";
import { CustomerState } from "../customer.state";
import { CustomersActions } from "./customers.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// HELPER
// ============================================================================

function withCustomer(state: PagesStore, updater: (customer: CustomerState) => CustomerState): PagesStore {
    return { ...state, customer: updater(state.customer) };
}

// ============================================================================
// CUSTOMERS LIST REDUCER (flattened structure)
// ============================================================================

const load = on(
    CustomersActions.load,
    (state: PagesStore) => withCustomer(state, customerState => ({
        ...customerState,
        loadingList: true,
    })),
);

// loadSuccess saves everything in one action
const loadSuccess = on(
    CustomersActions.loadSuccess,
    (state: PagesStore, { customers, params }) => withCustomer(state, customerState => ({
        ...customerState,
        customers: customers.data ?? [],
        loaded: true,
        pageNumber: customers.pagination?.pageNumber ?? 1,
        pageSize: customers.pagination?.pageSize ?? 50,
        totalCount: customers.pagination?.totalItemCount ?? 0,
        sortProperty: params.sorting.sortProperty,
        sortAscending: params.sorting.sortAscending,
        searchFilter: params.searchFilter,
        loadingList: false,
        error: null,
    })),
);

const loadFailure = on(
    CustomersActions.loadFailure,
    (state: PagesStore, { error }) => withCustomer(state, customerState => ({
        ...customerState,
        loadingList: false,
        error,
    })),
);

const invalidate = on(
    CustomersActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withCustomer(state, customerState => ({
        ...customerState,
        loaded: false,
    })),
);

const setVisibleColumns = on(
    CustomersActions.setVisibleColumns,
    (state: PagesStore, { visibleColumns }) => withCustomer(state, customerState => ({
        ...customerState,
        visibleColumns,
    })),
);

export const customersReducer = [load, loadSuccess, loadFailure, invalidate, setVisibleColumns];
